<template>
    <div data-cy="utilsContent-div-content" class="position-relative util-content pa-4">
        <!-- Botón de cierre para móvil -->
        <v-btn 
            icon 
            class="close-mobile-btn d-md-none" 
            @click="closeMobileUtils"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
        
        <slot name="header"></slot>
        <slot name="content"></slot>
        <slot name="actions"></slot>
    </div>
</template>
<script>
export default {
    name: 'UtilsContent',
    props:{
        contentWidth: {type: [String, Number], default: '35'},
        contentWidthUnit: {type: String, default: 'vw'}
    },
    computed: {
        size(){
            return `${this.contentWidth}${this.contentWidthUnit}`
        }
    },
    methods: {
        click() {
            this.$emit('close-action')
        },
        closeMobileUtils() {
            this.$emit('close-action')
        },
    },
}
</script>
<style lang="scss">
.util-content {
    background: #ffffff;
    border-radius: 1rem 1rem 0 0;
    z-index: 4;
}
.reading-card{
    .util-content{
        border: 2px solid whitesmoke;
        border-radius: 1rem;
        min-width: 365px;
        width: 50vw;
        z-index: 6;
        left: 2px;
        top: -4px;
        @media screen and (min-width: 1600px) {
            width: 45vw;
        }
        @media screen and (min-width: 1900px) {
            width: 40vw;
        }
        @media screen and (max-width: 767px) {
            top: 0px;
            left: 0px;
            width: 100vw;
            height: 100vh;
            border-radius: 0;
            z-index: 999;
            position: fixed;
        }
    }
}

/* Estilos específicos para challenge en móvil */
.utils-panel-challenge {
    .util-content {
        @media screen and (max-width: 767px) {
            top: 0px!important;
            left: 0px!important;
            width: 100vw!important;
            height: 100vh!important;
            border-radius: 0!important;
            z-index: 999!important;
            position: fixed!important;
            padding: 16px!important;
            box-sizing: border-box!important;
            display: flex!important;
            flex-direction: column!important;
            overflow-y: auto!important;
            
            /* Header del menú */
            .row:first-child {
                position: sticky!important;
                top: 0!important;
                background: white!important;
                z-index: 1001!important;
                margin: 0 0 16px 0!important;
                padding: 16px 56px 16px 16px!important; /* Espacio para X */
                box-shadow: 0 2px 8px rgba(0,0,0,0.1)!important;
                flex-shrink: 0!important;
            }
            
            /* App bar header centrado */
            .app-bar-header {
                width: 100%!important;
                
                .v-toolbar__content {
                    padding: 0!important;
                    justify-content: center!important;
                    align-items: center!important;
                }
                
                .v-btn[class*="mdi-arrow-left"] {
                    position: absolute!important;
                    left: 0!important;
                    top: 50%!important;
                    transform: translateY(-50%)!important;
                }
                
                .v-spacer {
                    display: none!important;
                }
            }
            
            /* Contenido de preguntas - mejorado para legibilidad */
            .questions-container,
            .d-flex.flex-column {
                width: 100%!important;
                max-width: 100%!important;
                padding: 0!important;
                margin: 0!important;
            }
            
            /* Mejorar legibilidad del texto */
            h1, h2, h3, h4, h5, h6,
            .text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6,
            .v-card-title {
                text-align: left!important;
                line-height: 1.4!important;
                margin-bottom: 16px!important;
            }
            
            p, span, div {
                text-align: left!important;
                line-height: 1.6!important;
                font-size: 16px!important;
            }
            
            /* Respuestas de preguntas más legibles */
            .v-radio-group,
            .v-input--radio-group {
                margin-top: 16px!important;
                
                .v-radio {
                    margin-bottom: 12px!important;
                    
                    .v-label {
                        font-size: 16px!important;
                        line-height: 1.5!important;
                        text-align: left!important;
                    }
                }
            }
            
            /* Botones de acción pegados abajo */
            .v-row:last-child {
                position: sticky!important;
                bottom: 0!important;
                background: white!important;
                margin: 16px 0 0 0!important;
                padding: 16px!important;
                box-shadow: 0 -2px 8px rgba(0,0,0,0.1)!important;
                z-index: 1001!important;
                flex-shrink: 0!important;
            }
        }
    }
}

/* Botón de cierre móvil mejorado */
.close-mobile-btn {
    position: fixed!important;
    top: 16px!important;
    right: 16px!important;
    z-index: 1003!important;
    background: rgba(81, 69, 133, 0.9)!important;
    color: white!important;
    backdrop-filter: blur(10px)!important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2)!important;
    min-width: 48px!important;
    min-height: 48px!important;
    border-radius: 50%!important;
    
    .v-icon {
        color: white!important;
        font-size: 24px!important;
    }
    
    &:hover {
        background: rgba(81, 69, 133, 1)!important;
        transform: scale(1.05)!important;
    }
}
.btn-close {
    top: -1rem;
    left: -1rem;
    @media screen and (max-width: 767px) {
        display: none!important; /* Ocultamos el botón original en móvil */
    }
}
</style>
